import { httpUrl } from "./httpUrl";
import { getData, ifOkToJson, post } from "./index";

let baseUrl = `${httpUrl.host}/gy-water`;
// let baseUrl = `${httpUrl.localapi}/gy-water`;
let baseUrl3 = `${httpUrl.host}/gy-electric`;
let baseUrl85 = `${httpUrl.host}/gy-apartment`;

let api = {
  // <!--概览-->
  // 概览 ———— 水表
  getWaterMeterDeviceOverview: `${baseUrl}/waterOverview/getWaterMeterDeviceOverview`,

  // 概览 ———— 集中器
  getWaterControlDeviceOverview: `${baseUrl}/waterOverview/getWaterControlDeviceOverview`,

  // 概览 ———— 当月用水量/水费
  getCurrentMonthWaterity: `${baseUrl}/waterOverview/getCurrentMonthWaterity`,

  // 概览 ———— 用水量统计
  getWaterityStatistics: `${baseUrl}/waterOverview/getWaterityStatistics`,

  // 概览 ———— 充值统计
  getWaterRechargeStatistics: `${baseUrl}/waterOverview/getStatistics`,
  // <!--概览-->

  // <!--设备管理-->
  // 设备管理 ———— 查询是否可配置欠费是否关闸
  autoOffSupport: `${baseUrl}/waterMeterDevice/autoOffSupport`,

  // 设备管理 ———— 集中器分页
  getWaterControlDevicePage: `${baseUrl}/waterControlDevice/getPage`,

  // 设备管理 ———— 集中器列表
  getWaterControlDeviceList: `${baseUrl}/waterControlDevice/getList`,

  // 设备管理 ———— 集中器详情
  getWaterControlDeviceByCode: `${baseUrl}/waterControlDevice/getByCode`,

  // 设备管理 ———— 集中器添加
  addWaterControlDevice: `${baseUrl}/waterControlDevice/add`,

  // 设备管理 ———— 集中器删除
  deleteWaterControlDeviceByCodes: `${baseUrl}/waterControlDevice/deleteByCodes`,

  // 设备管理 ———— 集中器修改
  updateWaterControlDevice: `${baseUrl}/waterControlDevice/update`,

  // 设备管理 ———— 水表分页
  getWaterMeterDevicePage: `${baseUrl}/waterMeterDevice/getPage`,

  // 设备管理 ———— 水表列表
  getWaterMeterDeviceList: `${baseUrl}/waterMeterDevice/getList`,

  // 设备管理 ———— 水表详情
  getWaterMeterDeviceByCode: `${baseUrl}/waterMeterDevice/getByCode`,

  // 设备管理 ———— 水表添加
  addWaterMeterDevice: `${baseUrl}/waterMeterDevice/add`,

  // 设备管理 ———— 水表删除
  deleteWaterMeterDeviceByCodes: `${baseUrl}/waterMeterDevice/deleteByCodes`,

  // 设备管理 ———— 水表修改
  updateWaterMeterDevice: `${baseUrl}/waterMeterDevice/update`,

  // 设备管理 ———— 手动开关
  updatePowerOnOrOff: `${baseUrl}/waterMeterDevice/updatePowerOnOrOff`,

  // 设备管理 ———— 导出水表
  exportWaterMeterDevice: `${baseUrl}/waterMeterDevice/export`,

  // 设备管理 ———— 导入水表
  importWaterMeterDevice: `${baseUrl}/waterMeterDevice/import`,

  // 设备管理 ———— 历史水量
  waterSupply: `${baseUrl}/waterSupply/getPage`,
  // <!--设备管理-->

  // <!--用水配置-->
  // 用水配置 ———— 收费配置
  getWaterPayConfig: `${baseUrl}/waterPayConfig/get`,

  // 用水配置 ———— 修改收费配置
  updateWaterPayConfig: `${baseUrl}/waterPayConfig/update`,

  // 用水配置 ———— 场景分页
  getWaterScenePage: `${baseUrl}/waterScene/getPage`,

  // 用水配置 ———— 场景列表
  getWaterSceneList: `${baseUrl}/waterScene/getList`,

  // 用水配置 ———— 场景添加
  addWaterScene: `${baseUrl}/waterScene/add`,

  // 用水配置 ———— 场景详情
  getWaterSceneByCode: `${baseUrl}/waterScene/getByCode`,

  // 用水配置 ———— 场景修改
  updateWaterScene: `${baseUrl}/waterScene/update`,

  // 用水配置 ———— 场景删除
  deleteWaterSceneByCodes: `${baseUrl}/waterScene/deleteByCodes`,
  // <!--用水配置-->

  // <!--用水统计-->
  // 用水统计 ———— 按水表统计查询
  getWaterBillMeterPage: `${baseUrl}/waterBillMeter/getPage`,

  getRoomBillMeterPage: `${baseUrl}/waterBillRoom/getPage`,

  // 用水统计 ———— 按水表统计导出
  exportWaterBillMeter: `${baseUrl}/waterBillMeter/export`,

  // 用水统计 ———— 按房间统计导出
  exportRoomWaterBillMeter: `${baseUrl}/waterBillRoom/export`,

  // 用水统计 ———— 按住户统计查询
  getWaterBillEnterprisePage: `${baseUrl}/waterBillEnterprise/getPage`,

  // 用水统计 ———— 按住户统计导出
  exportWaterBillEnterprise: `${baseUrl}/waterBillEnterprise/export`,
  // <!--用水统计-->

  // <!--余额管理-->
  // 余额管理 ———— 分页
  getWaterRentMoneyPage: `${baseUrl}/waterRoomMoney/getPage`,

  getWaterRoomMoneyPage: `${baseUrl}/waterRoomMoney/getPage`,

  // <!--余额管理-->

  // <!--充值记录-->
  // 充值记录 ———— 分页
  getWaterConsumptionRecordPage: `${baseUrl}/waterConsumptionRecord/getPage`,
  // <!--充值记录-->

  // <!--结算记录-->
  // 结算记录 ———— 分页
  getWaterSettlementPage: `${baseUrl}/waterSettlement/getPage`,
  // <!--结算记录-->

  // <!--设备状态日志-->
  // 设备状态日志 ———— 分页
  getWaterDeviceStatusPage: `${baseUrl}/waterDeviceStatus/getPage`,

  // 设备状态日志 ———— 导出
  exportWaterDeviceStatus: `${baseUrl}/waterDeviceStatus/export`,
  // <!--设备状态日志-->

  // 获取园区责任人
  getResponsiblePersonList: `${baseUrl85}/person/getResponsiblePersonList`,

  // 获取楼栋列表
  getBuildingList: `${baseUrl85}/building/getBuildingList`,

  //获取水费结算配置
  getWaterSettlementConfig: `${baseUrl}/waterSettlementConfig/get`,

  //水费结算配置保存
  saveWaterSettlementConfig: `${baseUrl}/waterSettlementConfig/save`,

  //级别水量统计
  getWaterLevelStatistics: `${baseUrl}/waterOverview/getStatistics`,

  //场景水量统计
  getWaterStatistics: `${baseUrl}/waterOverview/getSceneStatistics`,

  // 水表最新读数—分页
  getWaterRealRecordPage: `${baseUrl}/waterRealRecord/getPge`,

  // 水表最新读数—导出
  exportWaterRealRecord: `${baseUrl}/waterRealRecord/export`,

  // 生成水表标签
  generateCipherText: `${baseUrl}/codeScanning/generateCipherText`,

  // 导出水表标签
  exportCodeScanning: `${baseUrl}/codeScanning/export`,

  // 导出水表历史读数
  exportWaterSupply: `${baseUrl}/waterSupply/export`,

  // 导入水表管理
  importWaterMeter: `${baseUrl}/waterMeterDevice/import`,

  // 查询推送配置
  getBalanceConfig: `${baseUrl}/balancePushConfig/getBalanceConfig`,

  // 全部推送配置
  updateBalance: `${baseUrl}/balancePushConfig/updateBalance`,

  // 单个房间账户推送配置
  pushRoomBalanceConfig: `${baseUrl}/waterRoomMoney/pushBalanceConfig`,

  // 获取余额明细
  getAccountDetailsPage: `${baseUrl}/waterRoomAccountDetails/getPage`,

  // 导出房间余额
  exportWaterRoomMoney: `${baseUrl}/waterRoomMoney/export`,
};

export { api };



// WEBPACK FOOTER //
// ./src/view/api/WaterManagement.js